import React from 'react';

const currencyToFormat = {
  USD: 'en-US',
};

export const numberToCurrencyWithSymbol = (number, currency = 'USD', withDigits = true) => {
  let cleanNumber = number;
  if (Object.is(cleanNumber, -0)) {
    // if the number is negative zero, make it positive zero
    cleanNumber = 0;
  }
  return new Intl.NumberFormat(currencyToFormat[currency], {
    style: 'currency',
    currency,
    minimumFractionDigits: withDigits ? 2 : 0,
    maximumFractionDigits: withDigits ? 2 : 0,
  }).format(cleanNumber);
};

export const subunitsToCurrency = subunits => subunits / 100;

export const subunitsToCurrencyWithSymbol = ({subunits, currency = 'USD'}) =>
  numberToCurrencyWithSymbol(subunitsToCurrency(subunits), currency);

export const subunitsToCurrencyWithoutSymbol = (subunits, withDigits = false) =>
  numberToCurrency(subunitsToCurrency(subunits), withDigits);

export const subunitsToCurrencyWithoutDigits = (subunits, currency = 'USD') =>
  numberToCurrencyWithSymbol(subunitsToCurrency(subunits), currency, false);

export const numberToCurrency = (number, withDigits = true) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: withDigits ? 2 : 0,
    maximumFractionDigits: withDigits ? 2 : 0,
  }).format(number);

export const currencyToNumber = currencyString =>
  Number(currencyString.replaceAll('$', '').replaceAll(',', ''));

export const CurrencySubunitsFormat = ({subunits, currency, className = ''}) => (
  <span className={className}>{subunitsToCurrencyWithSymbol({subunits, currency})}</span>
);

const CurrencyFormat = ({amount, className = ''}) => (
  <span className={className}>{numberToCurrencyWithSymbol(amount)}</span>
);

export default CurrencyFormat;
